import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAgentAction,
  getAllAgentAction,
  importAgentAction,
} from "../ProjectSection/Agents/Store/Agent.action";
import CommonModal from "../CommonComponents/Modal/CommonModal";
import ImportAgent from "../ProjectSection/Agents/ImportAgent";
import { swalWarningMessage } from "../../../Constant/swalMessage";
import CommonPopup from "../CommonComponents/PopUpCards/CommonPopup";
import { ReactComponent as AddIcon } from "../../../assets/Images/AddIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/Images/DownloadIcon.svg";
import { ReactComponent as AgentImportIcon } from "../../../assets/Images/AgentImportIcon.svg";
import {
  getCustomWriteAccess,
  isVodexLoggedin,
} from "../CommonComponents/Common";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import DocsWidget from "../CommonComponents/DocWidget";

const AgentHeader = ({ handleAgentModal, callHistoryAccess }) => {
  const dispatch = useDispatch();
  const reducer: any = useSelector((state) => state);
  const { projectId } = useParams<{ projectId: string }>();
  const {
    AgentReducer: { agents },
  } = reducer;

  const [state, setState] = useState({
    show: false,
    heading: "Personality",
    importShow: false,
    selectedAgent: [],
    importSpin: false,
  });
  const [agentPopup, setAgentPopup] = useState(false);

  const { importShow, selectedAgent, importSpin } = state;

  const toggleImport = async (open) => {
    setState((prev) => ({
      ...prev,
      importShow: !prev.importShow,
    }));
    if (open) {
      await dispatch(getAllAgentAction());
    } else {
      setState((prev) => ({
        ...prev,
        selectedAgent: [],
      }));
    }
  };

  const toggle = () => {
    setState((prev) => ({
      ...prev,
      show: !prev.show,
    }));
  };

  const agentToggle = () => {
    setAgentPopup((prev) => !prev);
  };

  const saveImportAgent = async () => {
    if (selectedAgent?.length > 0) {
      setState((prev) => ({
        ...prev,
        importSpin: true,
      }));
      let obj = {
        projectId,
        agentId: [...selectedAgent],
      };
      const res: any = await dispatch(importAgentAction(obj));
      await dispatch(getAgentAction(projectId));
      if (res === true) {
        setAgentPopup(true);
      }
      setState((prev) => ({
        ...prev,
        importSpin: false,
        importShow: false,
        selectedAgent: [],
      }));
    } else {
      swalWarningMessage("Please select agents");
    }
  };

  const onChange = (selectedId) => {
    let copyData: any = selectedAgent;
    const find = copyData.find((id) => id === selectedId);
    if (find) {
      copyData = [...copyData].filter((item) => {
        return item !== selectedId;
      });
    } else {
      copyData.push(selectedId);
    }
    setState((prev) => ({
      ...prev,
      selectedAgent: copyData,
    }));
  };

  const obj = {
    setMainState: setState,
    toggle,
    onChange,
    mainState: state,
  };

  return (
    <Box className="flex-between gap-2" sx={{ pb: 4 }}>
      <Box className="flex-xy-center gap-2">
        <Typography className="font-20-grey">Agents</Typography>
        <Typography
          className="font-14-lightgrey"
          component="span"
          sx={commonStyles.textInfo}
        >
          Available{" "}
          <span className="font-20-700-lightgrey">{agents?.length || 0}</span>
        </Typography>
      </Box>
      <Box className="flex-xy-center" gap={1}>
        {isVodexLoggedin() && (
          <DocsWidget docsRoute={"/agents/overview"} styles={{ py: "7.5px" }} />
        )}
        {getCustomWriteAccess(reducer) === "write" && !callHistoryAccess && (
          <Box className="flex-xy-center" gap={1}>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() => toggleImport(true)}
            >
              Import Agents
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAgentModal}
            >
              Add New Agent
            </Button>
          </Box>
        )}
      </Box>
      {importShow && (
        <CommonModal
          show={importShow}
          toggle={() => toggleImport(false)}
          heading={`Import Agent`}
          body={<ImportAgent obj={obj} />}
          size={600}
          handleSave={saveImportAgent}
          spin={importSpin}
          saveButtonText="Import"
          footer={true}
        />
      )}
      {agentPopup && (
        <CommonPopup
          message={`Agent added Successfully`}
          show={agentPopup}
          toggle={agentToggle}
          Icon={AgentImportIcon}
          heading="Imported Successfully"
        />
      )}
    </Box>
  );
};

export default AgentHeader;
